import React, { useState, useEffect } from "react";
import GameOverModal from "../../../components/GameOverModal";
import GameWonModal from "../../../components/GameWonModal";
import { useDarkMode } from "../../../context/DarkModeProvider";
import "../../../assets/css/colors.css";
import { useLanguage } from "context/LanguageProvider";
import "../../../assets/css/colors.css"

const DoublyLinkedListSearchGame = () => {
    const { darkMode } = useDarkMode();
    const TARGET_POSITION = 4;
    const TOTAL_NODES = 9;
    const QUESTION_TIME = 10;
    const START_POSITION = 8;

    const selectedStage = JSON.parse(localStorage.getItem("selectedStage"));

    var games = selectedStage.games;
    var nameGameKey = localStorage.getItem("gameClicked");
    var selectedGame = null;
    for (let i = 0; i < games.length; i++) {
        if (games[i].game_title === nameGameKey) {
            selectedGame = games[i];
            break;
        }
    }

    const [currentPosition, setCurrentPosition] = useState(START_POSITION);
    const [lives, setLives] = useState(3);
    const [showQuestion, setShowQuestion] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [timeLeft, setTimeLeft] = useState(QUESTION_TIME);
    const [showGameOver, setShowGameOver] = useState(false);
    const [showGameWon, setShowGameWon] = useState(false);
    const [usedQuestions, setUsedQuestions] = useState([]);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [showFeedback, setShowFeedback] = useState(false);
    const { selLanguage, toggleLanguage, isLoading } = useLanguage();

    const mission = selLanguage ? "Στόχος σου είναι η αναζήτηση του αριθμού 5. Για κάθε κόμβο που θα επιλέγεις θα πρέπει να απαντήσεις μια ερώτηση θεωρίας η οποία θα σου επιτρέπει να συνεχίσεις αν η απάντηση είναι σωστή." : "Your goal is to search for the number 5. For each node you select, you must answer a theory question, which will allow you to continue only if your answer is correct."


    const questions = [
        {
            question: selLanguage
                ? "Η χρονική πολυπλοκότητα της αναζήτησης σε διπλά συνδεδεμένη λίστα είναι O(log n) λόγω της ύπαρξης του prev δείκτη"
                : "The time complexity of searching in a doubly linked list is O(log n) because of the prev pointer.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Η χρονική πολυπλοκότητα παραμένει O(n), καθώς στη χειρότερη περίπτωση χρειάζεται να διατρέξουμε ολόκληρη τη λίστα"
                : "Wrong! The time complexity is still O(n), since in the worst case we must traverse the entire list."
        },
        {
            question: selLanguage
                ? "Η αναζήτηση μπορεί να ξεκινήσει είτε από το head είτε από το tail, ανάλογα με ποια κατεύθυνση θεωρείται πιο σύντομη"
                : "Searching can start either from the head or from the tail, depending on which direction is shorter.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Η ύπαρξη των δύο δεικτών (prev και next) δίνει μεγαλύτερη ευελιξία στην πλοήγηση"
                : "Correct! Having both prev and next pointers gives more flexibility in navigation."
        },
        {
            question: selLanguage
                ? "Η επαναληπτική αναζήτηση απαιτεί επιπλέον στοίβα κλήσεων σε αντίθεση με την αναδρομική"
                : "Iterative search requires extra call stack space compared to recursive search.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Η επαναληπτική είναι αποδοτική στη χρήση μνήμης και ΔΕΝ απαιτεί επιπλέον στοίβα κλήσεων. Η αναδρομική καταναλώνει επιπλέον μνήμη στη στοίβα"
                : "Wrong! The iterative method is memory-efficient and does NOT need extra call stack space. The recursive method consumes extra stack memory."
        },
        {
            question: selLanguage
                ? "Στην επαναληπτική αναζήτηση, αν current == NULL σημαίνει ότι φτάσαμε στο τέλος χωρίς να βρούμε το στοιχείο"
                : "In iterative search, if current == NULL it means we reached the end without finding the element.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Αν φτάσουμε στο τέλος (current == NULL) χωρίς εύρεση, επιστρέφουμε NULL"
                : "Correct! If we reach the end (current == NULL) without finding it, we return NULL."
        },
        {
            question: selLanguage
                ? "Η αναδρομική αναζήτηση για πολύ μεγάλες λίστες μπορεί να προκαλέσει σφάλμα υπερχείλισης στοίβας (stack overflow)"
                : "Recursive search on very large lists may cause a stack overflow error.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Κατανάλωση επιπλέον μνήμης στη στοίβα κλήσεων μπορεί να προκαλέσει stack overflow"
                : "Correct! Extra memory usage on the call stack can cause a stack overflow."
        },
        {
            question: selLanguage
                ? "Στην αναδρομική αναζήτηση από το head, η περίπτωση τερματισμού είναι μόνο όταν βρούμε το στοιχείο"
                : "In recursive search starting from the head, the termination case is only when we find the element.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Η περίπτωση τερματισμού είναι και όταν current == NULL (τέλος λίστας χωρίς εύρεση)"
                : "Wrong! Another termination case is when current == NULL (end of list without finding it)."
        },
        {
            question: selLanguage
                ? "Κάθε κόμβος διαθέτει δύο δείκτες: έναν προς τον επόμενο (next) και έναν προς τον προηγούμενο (prev)"
                : "Each node has two pointers: one to the next node (next) and one to the previous node (prev).",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Αυτό είναι το χαρακτηριστικό γνώρισμα της διπλά συνδεδεμένης λίστας"
                : "Correct! This is the key feature of a doubly linked list."
        },
        {
            question: selLanguage
                ? "Η αναζήτηση από το tail προς το head χρησιμοποιεί τον δείκτη next για να κινηθεί προς τα πίσω"
                : "Searching from tail to head uses the next pointer to move backwards.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Η αναζήτηση από το tail χρησιμοποιεί τον δείκτη prev για να κινηθεί προς τα πίσω"
                : "Wrong! Searching from the tail uses the prev pointer to move backwards."
        },
        {
            question: selLanguage
                ? "Η επαναληπτική υλοποίηση είναι πιο απλή και αποδοτική στη χρήση μνήμης από την αναδρομική"
                : "The iterative implementation is simpler and more memory-efficient than the recursive one.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Η επαναληπτική είναι απλή στην υλοποίηση και αποδοτική στη χρήση μνήμης"
                : "Correct! Iteration is simple to implement and efficient in memory usage."
        },
        {
            question: selLanguage
                ? "Στην αναδρομική υλοποίηση, καλούμε αναδρομικά τη συνάρτηση με current->prev για αναζήτηση από το head"
                : "In the recursive implementation, we call the function recursively with current->prev when searching from the head.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Από το head καλούμε με current->next. Το prev χρησιμοποιείται για αναζήτηση από το tail"
                : "Wrong! From the head we call it with current->next. prev is used when searching from the tail."
        },
        {
            question: selLanguage
                ? "Η αναζήτηση μπορεί να προσαρμοστεί ώστε να επιστρέφει τη θέση του κόμβου ή να χειρίζεται πολλαπλές εμφανίσεις"
                : "Search can be adapted to return the position of the node or to handle multiple occurrences.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Η αναζήτηση μπορεί να προσαρμοστεί για διάφορες ανάγκες"
                : "Correct! The search function can be customized for different needs."
        },
        {
            question: selLanguage
                ? "Σε ταξινομημένες λίστες, η αναζήτηση μπορεί να τερματιστεί πρώιμα αν το τρέχον στοιχείο υπερβαίνει το ζητούμενο"
                : "In sorted lists, the search can terminate early if the current element exceeds the target.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Μπορούμε να εκμεταλλευτούμε ταξινομημένες λίστες για πρώιμο τερματισμό"
                : "Correct! We can leverage sorted lists for early termination."
        },
        {
            question: selLanguage
                ? "Η αναδρομική προσέγγιση είναι πιο κομψή και ευανάγνωστη αλλά καταναλώνει περισσότερη μνήμη"
                : "The recursive approach is more elegant and readable but consumes more memory.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Αυτά είναι τα βασικά χαρακτηριστικά της αναδρομικής μεθόδου"
                : "Correct! These are the main characteristics of the recursive method."
        },
        {
            question: selLanguage
                ? "Στην επαναληπτική μέθοδο, ο έλεγχος current->data == target γίνεται πριν τον έλεγχο current != NULL"
                : "In the iterative method, we check current->data == target before checking current != NULL.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Πρέπει πρώτα να ελέγξουμε current != NULL για να αποφύγουμε segmentation fault"
                : "Wrong! We must first check current != NULL to avoid a segmentation fault."
        },
        {
            question: selLanguage
                ? "Η ύπαρξη του prev δείκτη επιτρέπει την αναζήτηση και από το τέλος προς την αρχή της λίστας"
                : "The presence of the prev pointer allows searching from the end of the list back to the beginning.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Αυτό δίνει μεγαλύτερη ευελιξία στην πλοήγηση και προσαρμοστικότητα"
                : "Correct! This gives more flexibility and adaptability in navigation."
        },
        {
            question: selLanguage
                ? "Η χρονική πολυπλοκότητα βελτιώνεται σε O(n/2) αν αποφασίσουμε να ψάχνουμε από το πλησιέστερο άκρο"
                : "Time complexity improves to O(n/2) if we decide to search from the nearest end.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Παρόλο που μπορεί να μειωθεί ο μέσος αριθμός επαναλήψεων, η ασυμπτωτική πολυπλοκότητα παραμένει O(n)"
                : "Wrong! Although the average number of iterations may decrease, the asymptotic complexity is still O(n)."
        },
        {
            question: selLanguage
                ? "Στην αναδρομική υλοποίηση, αν current->data == target επιστρέφουμε τον current κόμβο"
                : "In the recursive implementation, if current->data == target we return the current node.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Αυτή είναι μία από τις περιπτώσεις τερματισμού της αναδρομής"
                : "Correct! This is one of the recursion’s termination cases."
        },
        {
            question: selLanguage
                ? "Η γραμμική επανάληψη από το head προς το tail εξετάζει διαδοχικά κάθε κόμβο μέσω του δείκτη prev"
                : "Linear iteration from head to tail checks each node sequentially using the prev pointer.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Από το head προς το tail χρησιμοποιούμε τον δείκτη next"
                : "Wrong! From head to tail we use the next pointer."
        },
        {
            question: selLanguage
                ? "Αν το αναζητούμενο στοιχείο εκτιμάται ότι βρίσκεται προς το τέλος, είναι πιο αποδοτικό να ξεκινήσουμε από το tail"
                : "If the target element is estimated to be near the end, it is more efficient to start from the tail.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Η αναζήτηση μπορεί να ξεκινήσει από το tail χρησιμοποιώντας τον δείκτη prev"
                : "Correct! The search can start from the tail using the prev pointer."
        },
        {
            question: selLanguage
                ? "Στην επαναληπτική μέθοδο, ο δείκτης current αρχικοποιείται στο NULL και προχωράει μέχρι το head"
                : "In the iterative method, the current pointer is initialized to NULL and moves up to the head.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Ο current αρχικοποιείται στο head και προχωράει μέχρι να γίνει NULL"
                : "Wrong! current is initialized to the head and moves forward until it becomes NULL."
        }
    ];


    useEffect(() => {
        if (lives <= 0) {
            setShowGameOver(true);
        }
    }, [lives]);

    useEffect(() => {
        if (currentPosition === TARGET_POSITION) {
            setShowGameWon(true);
        }
    }, [currentPosition]);

    useEffect(() => {
        let timer;
        if (showQuestion && timeLeft > 0 && !showFeedback) {
            timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
        } else if (timeLeft === 0 && !showFeedback) {
            handleTimeout();
        }
        return () => clearTimeout(timer);
    }, [showQuestion, timeLeft, showFeedback]);

    const getRandomQuestion = () => {
        const availableQuestions = questions.filter(
            (_, index) => !usedQuestions.includes(index)
        );

        if (availableQuestions.length === 0) {
            setUsedQuestions([]);
            return questions[Math.floor(Math.random() * questions.length)];
        }

        const randomIndex = Math.floor(Math.random() * availableQuestions.length);
        const selectedQuestion = availableQuestions[randomIndex];
        const originalIndex = questions.indexOf(selectedQuestion);

        setUsedQuestions([...usedQuestions, originalIndex]);
        return selectedQuestion;
    };

    const handleNodeClick = (position) => {
        if (showQuestion || position > currentPosition) return;

        if (position !== currentPosition) {
            setLives(lives - 1);
            return;
        }

        const question = getRandomQuestion();
        setCurrentQuestion(question);
        setShowQuestion(true);
        setTimeLeft(QUESTION_TIME);
        setSelectedAnswer(null);
        setShowFeedback(false);
    };

    const handleAnswer = (answer) => {
        setSelectedAnswer(answer);
        setShowFeedback(true);

        setTimeout(() => {
            if (answer === currentQuestion.answer) {
                setCurrentPosition(currentPosition - 1);
            } else {
                setLives(lives - 1);
            }
            setShowQuestion(false);
            setShowFeedback(false);
            setSelectedAnswer(null);
        }, 2500);
    };

    const handleTimeout = () => {
        setSelectedAnswer(null);
        setShowFeedback(true);

        setTimeout(() => {
            setLives(lives - 1);
            setShowQuestion(false);
            setShowFeedback(false);
        }, 2500);
    };

    const resetGame = () => {
        setShowGameOver(false);
        setShowGameWon(false);
        setCurrentPosition(START_POSITION);
        setLives(3);
        setShowQuestion(false);
        setCurrentQuestion(null);
        setTimeLeft(QUESTION_TIME);
        setUsedQuestions([]);
        setSelectedAnswer(null);
        setShowFeedback(false);
    };

    const renderNodes = () => {
        const nodes = [];
        for (let i = 0; i < TOTAL_NODES; i++) {
            const isActive = i === currentPosition;
            const isPassed = i > currentPosition;
            const isTarget = i === TARGET_POSITION;

            nodes.push(
                <React.Fragment key={i}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
                        <div
                            style={{
                                width: '70px',
                                height: '70px',
                                borderRadius: '50%',
                                background: isPassed
                                    ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                                    : isActive
                                        ? 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
                                        : 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                color: 'white',
                                fontWeight: '700',
                                fontSize: '1.4rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: isActive
                                    ? '0 8px 20px rgba(59, 130, 246, 0.5)'
                                    : '0 4px 12px rgba(0, 0, 0, 0.2)',
                                border: '3px solid rgba(255, 255, 255, 0.3)',
                                transition: 'all 0.3s ease',
                                cursor: isPassed ? 'not-allowed' : 'pointer',
                                opacity: isPassed ? 0.7 : 1,
                                position: 'relative',
                                animation: isActive ? 'pulse 2s ease-in-out infinite' : 'none',
                                zIndex: 10
                            }}
                            onClick={() => handleNodeClick(i)}
                            onMouseEnter={(e) => {
                                if (!isPassed) e.currentTarget.style.transform = 'scale(1.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                        >
                            <span style={{ pointerEvents: 'none' }}>{i}</span>
                            {isTarget && (
                                <div style={{
                                    position: 'absolute',
                                    top: '-35px',
                                    fontSize: '24px'
                                }}>
                                    🎯
                                </div>
                            )}
                        </div>
                    </div>

                    {i < TOTAL_NODES - 1 && (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            position: 'relative'
                        }}>
                            {/* Next Arrow (top) */}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '2px'
                            }}>

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{
                                        width: '40px',
                                        height: '3px',
                                        background: 'linear-gradient(90deg, #3b82f6 0%, #60a5fa 100%)',
                                        boxShadow: '0 2px 6px rgba(59, 130, 246, 0.3)'
                                    }}></div>
                                    <div style={{
                                        width: '0',
                                        height: '0',
                                        borderLeft: '10px solid #3b82f6',
                                        borderTop: '6px solid transparent',
                                        borderBottom: '6px solid transparent',
                                        filter: 'drop-shadow(0 2px 4px rgba(59, 130, 246, 0.4))'
                                    }}></div>
                                </div>
                            </div>

                            {/* Prev Arrow (bottom) */}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '2px'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{
                                        width: '0',
                                        height: '0',
                                        borderRight: '10px solid #ef4444',
                                        borderTop: '6px solid transparent',
                                        borderBottom: '6px solid transparent',
                                        filter: 'drop-shadow(0 2px 4px rgba(239, 68, 68, 0.4))'
                                    }}></div>
                                    <div style={{
                                        width: '40px',
                                        height: '3px',
                                        background: 'linear-gradient(90deg, #f87171 0%, #ef4444 100%)',
                                        boxShadow: '0 2px 6px rgba(239, 68, 68, 0.3)'
                                    }}></div>
                                </div>

                            </div>
                        </div>
                    )}
                </React.Fragment>
            );
        }
        return nodes;
    };

    return (
        <div style={{
            minHeight: '90vh',
            background: darkMode
                ? 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #101724ff 100%)'
                : 'var(--lightModeGameBackground)',
            padding: '30px 10px',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            borderRadius: "20px"
        }}>

            <GameOverModal
                isVisible={showGameOver}
                onPlayAgain={resetGame}

            />

            <GameWonModal
                isVisible={showGameWon}
                onPlayAgain={resetGame}

            />
            <style>{`
                @keyframes pulse {
                    0%, 100% { transform: scale(1); box-shadow: 0 8px 20px rgba(59, 130, 246, 0.5); }
                    50% { transform: scale(1.05); box-shadow: 0 12px 30px rgba(59, 130, 246, 0.7); }
                }
                @keyframes heartbeat {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                }
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes slideInBounce {
                    0% { opacity: 0; transform: scale(0.5) translateY(-50px); }
                    70% { transform: scale(1.05) translateY(0); }
                    100% { opacity: 1; transform: scale(1) translateY(0); }
                }
                @keyframes shimmer {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
                @keyframes feedbackAppear {
                    0% { opacity: 0; transform: scale(0.8) rotate(-5deg); }
                    100% { opacity: 1; transform: scale(1) rotate(0deg); }
                }
                @keyframes iconBounce {
                    0%, 100% { transform: translateY(0); }
                    25% { transform: translateY(-20px); }
                    50% { transform: translateY(-10px); }
                    75% { transform: translateY(-15px); }
                }
            `}</style>

            <div style={{ width: '100%', maxWidth: '1200px' }}>
                {/* Lives Display */}
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px'
                    }}>

                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                            {[1, 2, 3].map((heartNum) => (
                                <div
                                    key={heartNum}
                                    style={{
                                        fontSize: '24px',
                                        filter: lives >= heartNum
                                            ? 'drop-shadow(0 4px 8px rgba(220, 38, 38, 0.4))'
                                            : 'grayscale(100%) opacity(0.3)',
                                        transform: lives >= heartNum ? 'scale(1)' : 'scale(0.8)',
                                        transition: 'all 0.3s ease',
                                        animation: lives >= heartNum ? 'heartbeat 2s ease-in-out infinite' : 'none'
                                    }}
                                >
                                    ❤️
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Instructions */}
                <div style={{
                    borderRadius: '20px',
                    maxWidth: '900px',
                    background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.4), rgba(29, 78, 216, 0.4))',
                    width: '90%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '15px 20px',
                    margin: '0 auto 20px',
                    color: 'white',
                    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
                    textAlign: 'center',
                    lineHeight: '1.6'
                }}>
                    {mission}
                </div>

                {/* Linked List Visualization */}
                <div style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '850px',
                    aspectRatio: '3/2',
                    border: '3px solid #3b82f6',
                    borderRadius: '20px',
                    margin: '0 auto 30px',
                    background: '#ffffffde',
                    boxShadow: 'inset 0 2px 10px rgba(0, 0, 0, 0.1), 0 10px 25px rgba(59, 130, 246, 0.15)',
                    overflow: 'hidden',
                    minHeight: '350px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        padding: '20px',
                        flexWrap: 'wrap'
                    }}>
                        {renderNodes()}
                    </div>
                </div>

                {/* Question Modal */}
                {showQuestion && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0, 0, 0, 0.85)',
                        backdropFilter: 'blur(8px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                        padding: '20px',
                        animation: 'fadeIn 0.3s ease-out'
                    }}>
                        <div style={{
                            background: darkMode ? 'linear-gradient(145deg, #1f2937 0%, #374151 100%)' : "var(--lightModeModal)",
                            borderRadius: '24px',
                            padding: '40px',
                            maxWidth: '700px',
                            width: '100%',
                            boxShadow: '0 25px 80px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1)',
                            position: 'relative',
                            animation: 'slideInBounce 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                        }}>
                            {/* Timer Bar */}
                            <div style={{
                                width: '100%',
                                height: '12px',
                                background: '#e2e8f0',
                                borderRadius: '20px',
                                overflow: 'hidden',
                                marginBottom: '20px',
                                boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                                border: '2px solid #cbd5e1'
                            }}>
                                <div style={{
                                    height: '100%',
                                    width: `${(timeLeft / QUESTION_TIME) * 100}%`,
                                    background: '#7A8EFF',
                                    transition: 'width 1s linear',
                                    borderRadius: '20px',
                                    boxShadow: '0 0 10px rgba(122, 142, 255, 0.5)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
                                        animation: 'shimmer 2s infinite'
                                    }}></div>
                                </div>
                            </div>

                            {/* Timer Display */}
                            <div style={{
                                textAlign: 'center',
                                fontSize: '32px',
                                fontWeight: '800',
                                color: '#dc2626',
                                marginBottom: '25px',
                                textShadow: '0 2px 8px rgba(220, 38, 38, 0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '10px'
                            }}>
                                <span style={{
                                    fontFamily: '"Courier New", monospace',
                                    background: 'linear-gradient(135deg, #dc2626, #ef4444)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text'
                                }}>
                                    {timeLeft}s
                                </span>
                            </div>

                            {/* Question Text */}
                            <h3 style={{
                                fontSize: '20px',
                                color: '#0f172a',
                                textAlign: 'center',
                                marginBottom: '35px',
                                lineHeight: '1.8',
                                fontWeight: '600',
                                padding: '20px',
                                background: '#eaeaea',
                                borderRadius: '16px',
                                borderLeft: '5px solid #3b82f6',
                                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.1)'
                            }}>
                                {currentQuestion?.question}
                            </h3>

                            {showFeedback ? (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '30px',
                                    borderRadius: '16px',
                                    animation: 'feedbackAppear 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                                    border: '3px solid',
                                    background: selectedAnswer === currentQuestion?.answer
                                        ? 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)'
                                        : 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                                    borderColor: selectedAnswer === currentQuestion?.answer
                                        ? '#10b981'
                                        : '#ef4444',
                                    boxShadow: selectedAnswer === null
                                        ? '0 10px 30px rgba(245, 158, 11, 0.3)'
                                        : selectedAnswer === currentQuestion?.answer
                                            ? '0 10px 30px rgba(16, 185, 129, 0.3)'
                                            : '0 10px 30px rgba(239, 68, 68, 0.3)'
                                }}>
                                    <div style={{
                                        fontSize: '80px',
                                        marginBottom: '15px',
                                        animation: 'iconBounce 0.8s ease-in-out'
                                    }}>
                                    </div>
                                    <p style={{
                                        fontSize: '24px',
                                        fontWeight: '800',
                                        margin: '15px 0',
                                        letterSpacing: '1px',
                                        color: selectedAnswer === currentQuestion?.answer
                                            ? '#047857'
                                            : '#b91c1c'
                                    }}>
                                        {
                                            selLanguage
                                                ? (
                                                    selectedAnswer === null
                                                        ? 'Ο χρόνος τελείωσε!'
                                                        : selectedAnswer === currentQuestion?.answer
                                                            ? 'Σωστή απάντηση!'
                                                            : 'Λάθος απάντηση!'
                                                )
                                                : (
                                                    selectedAnswer === null
                                                        ? 'Time is up!'
                                                        : selectedAnswer === currentQuestion?.answer
                                                            ? 'Correct answer!'
                                                            : 'Wrong answer!'
                                                )
                                        }
                                    </p>

                                </div>
                            ) : (
                                <div style={{
                                    display: 'flex',
                                    gap: '20px',
                                    justifyContent: 'center'
                                }}>
                                    <button
                                        onClick={() => handleAnswer(true)}
                                        style={{
                                            flex: 1,
                                            padding: '18px 40px',
                                            fontSize: '20px',
                                            fontWeight: '700',
                                            border: 'none',
                                            borderRadius: '16px',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                                            background: 'linear-gradient(135deg, #506ce9ff, #334597ff)',
                                            color: 'white'
                                        }}
                                        onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px) scale(1.03)'}
                                        onMouseLeave={(e) => e.target.style.transform = 'translateY(0) scale(1)'}
                                    >
                                        {selLanguage ? "Σωστό" : "True"}
                                    </button>
                                    <button
                                        onClick={() => handleAnswer(false)}
                                        style={{
                                            flex: 1,
                                            padding: '18px 40px',
                                            fontSize: '20px',
                                            fontWeight: '700',
                                            border: 'none',
                                            borderRadius: '16px',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                                            background: 'linear-gradient(135deg, #b81e1eff 0%, #7c0505ff 100%)',
                                            color: 'white'
                                        }}
                                        onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px) scale(1.03)'}
                                        onMouseLeave={(e) => e.target.style.transform = 'translateY(0) scale(1)'}
                                    >
                                        {selLanguage ? "Λάθος" : "False"}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default DoublyLinkedListSearchGame;